export default {
  options(h, conf, key) {
    const list = [];
    conf.__slot__.options.forEach((item) => {
      list.push(<van-radio name={item.value}>{item.label}</van-radio>);
    });
    return list;
  },
};
